<template>
  <div class="tinymce-editor">
    <editor
      v-if="!reloading"
      v-model="myValue"
      id=""
      :init="init"
      :disabled="disabled"
      @onClick="onClick">
    </editor>
  </div>
</template>

<script>
  import tinymce from 'tinymce/tinymce'
  import Editor from '@tinymce/tinymce-vue'
  import 'tinymce/themes/silver/theme'
  import 'tinymce/plugins/image'
  import 'tinymce/plugins/paste'
  import 'tinymce/plugins/link'
  import 'tinymce/plugins/media'
  import 'tinymce/plugins/table'
  import 'tinymce/plugins/lists'
  import 'tinymce/plugins/contextmenu'
  import 'tinymce/plugins/wordcount'
  import 'tinymce/plugins/colorpicker'
  import 'tinymce/plugins/textcolor'
  import 'tinymce/plugins/fullscreen'
  import 'tinymce/icons/default'
  import { uploadAction,getFileAccessHttpUrl } from '@/api/manage'
  import { getVmParentByName } from '@/utils/util'
  export default {
    components: {
      Editor
    },
    computed: {
        language() {
            return this.$store.getters.language
        }
    },
    props: {
      value: {
        type: String,
        required:false
      },
      uploadSource:{
        type: String,
        required: false,
        default: "platform"
      },
      triggerChange:{
        type: Boolean,
        default: false,
        required:false
      },
      disabled: {
        type: Boolean,
        default: false
      },
      plugins: {
        type: [String, Array],
        default: 'lists image paste link media table textcolor wordcount contextmenu fullscreen'
      },
      toolbar: {
        type: [String, Array],
        default: 'undo redo |  formatselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | lists link unlink image media table | removeformat | fullscreen',
        branding:false
      },
      limit: {
          type: Number,
          default: 10000
      },
      height: {
        type: Number,
        default: 300
      }
    },
    data() {
      return {
          isChinese: false,
          limitTip: 0,
        //初始化配置
        init: {
          language_url: '/web/tinymce/langs/zh_CN.js',
          language: 'zh_CN',
          skin_url: '/web/tinymce/skins/lightgray',
          height: this.height,
          plugins: this.plugins,
          // 允许直接粘贴data图片
          paste_data_images: true,
          toolbar: this.toolbar,
          branding: false,
          menubar: false,
          toolbar_drawer: false,
          convert_urls: false, // 设置带有域名的路径不会被转换为相对路径
          // relative_urls : false,
          images_upload_handler: (blobInfo, success, failure) => {
            let formData = new FormData()
            formData.append('file', blobInfo.blob(), blobInfo.filename());
            formData.append('biz', "jeditor");
            formData.append("jeditor","1");
            let url = window._CONFIG['domianURL']+"/sys/common/upload?isShiro=0";
            if(this.uploadSource){
              url = window._CONFIG['domianURL']+"/sys/common/upload"+ "?applicationCode="+this.uploadSource+"&isShiro=0";
            }

            const filename = blobInfo.filename()
            // 对于特殊字符处理
            if (filename.match(/[?%:;\[\]]/g)) {
              failure('文件名不允许包含特殊字符?%:;[]')
              return
            }

            uploadAction(url, formData).then((res) => {
              if (res.success) {
                if(res.message == 'local'){
                  const img = 'data:image/jpeg;base64,' + blobInfo.base64()
                  success(img)
                }else{
                  let img = getFileAccessHttpUrl(res.message, this.uploadSource)
                  success(img)
                }
              }
            })
          },
          init_instance_callback: (editor) => {
              editor.on('paste', (e) => {
                e.preventDefault();
                var contentOnBlur = (e.originalEvent || e).clipboardData.getData('text/plain');
                contentOnBlur = contentOnBlur.replace(/(<([^>]+)>)/ig, '');
                if (!(this.limit - e.target.innerText.length) && !this.limitTip) {
                    this.$message.error(this.language['ispforum.limit.start'] + ` ${this.limit} ` + this.language['ispforum.limit.end'])
                    this.limitTip++
                    // 5s 后重置提示
                    setTimeout(() => {
                        this.limitTip = 0
                    }, 5000)
                }
                const ifra = document.querySelector('iframe[id^=tiny-vue_]')
                if (ifra) ifra.contentWindow.document.execCommand('insertText', true, contentOnBlur.slice(0, this.limit - e.target.innerText.length))
            });
          },
          setup: (editor) => {
              const vm = this
              editor.on('keyup', (e) => {
                  vm.handleWordLimit(e)
              })
              editor.on('input', (e) => {
                  vm.handleWordLimit(e)
              })
              editor.on('compositionstart', () => {
                  vm.isChinese = false
              })
              editor.on('compositionend', () => {
                  vm.isChinese = true
              })
          }
        },
        myValue: this.value,
        reloading: false,
      }
    },
    mounted() {
      this.initATabsChangeAutoReload()
    },
    methods: {
        // 字数限制
        handleWordLimit(e) {
            if (e.target.innerText.length === this.limit) {
                this.htmlText = e.target.innerHTML
            }
            if (e.target.innerText.length > this.limit) {
                e.target.innerHTML = this.htmlText
                if (!this.limitTip) {
                    this.$message.error(this.language['ispforum.limit.start'] + ` ${this.limit} ` + this.language['ispforum.limit.end'])
                    this.limitTip++
                    // 5s 后重置提示
                    setTimeout(() => {
                        this.limitTip = 0
                    }, 5000)
                }
            }
        },
      reload() {
        this.reloading = true
        this.$nextTick(() => this.reloading = false)
      },

      onClick(e) {
        this.$emit('onClick', e, tinymce)
      },
      //可以添加一些自己的自定义事件，如清空内容
      clear() {
        this.myValue = ''
      },

      /**
       * 自动判断父级是否是 <a-tabs/> 组件，然后添加事件监听，自动触发reload()
       *
       * 由于 tabs 组件切换会导致 tinymce 无法输入，
       * 只有重新加载才能使用（无论是vue版的还是jQuery版tinymce都有这个通病）
       */
      initATabsChangeAutoReload() {
        // 获取父级
        let tabs = getVmParentByName(this, 'ATabs')
        let tabPane = getVmParentByName(this, 'ATabPane')
        if (tabs && tabPane) {
          // 用户自定义的 key
          let currentKey = tabPane.$vnode.key
          // 添加事件监听
          tabs.$on('change', (key) => {
            // 切换到自己时执行reload
            if (currentKey === key) {
              this.reload()
            }
          })
          //update--begin--autor:liusq-----date:20210316------for：富文本编辑器tab父组件可能导致的赋值问题------
          this.reload()
          //update--end--autor:liusq-----date:20210316------for：富文本编辑器tab父组件可能导致的赋值问题------
        }else{
          //update--begin--autor:wangshuai-----date:20200724------for：富文本编辑器切换tab无法修改------
          let tabLayout = getVmParentByName(this, 'TabLayout')
          //update--begin--autor:liusq-----date:20210713------for：处理特殊情况excuteCallback不能使用------
          try {
            tabLayout.excuteCallback(() => {
              this.reload()
            })
          } catch (error) {
            if (tabLayout) {
              this.reload()
            }
          }
          //update--end--autor:liusq-----date:20210713------for：处理特殊情况excuteCallback不能使用------
          //update--begin--autor:wangshuai-----date:20200724------for：文本编辑器切换tab无法修改------
        }
      },

    },
    watch: {
      value(newValue) {
        this.myValue = (newValue == null ? '' : newValue)
      },
      myValue(newValue) {
        if(this.triggerChange){
          this.$emit('change', newValue)
        }else{
          this.$emit('input', newValue)
        }
      }
    }
  }

</script>
<style lang="less" scoped>
/deep/ .tox .tox-statusbar {
    display: none !important;
}
</style>
